export default __webpack_public_path__ + "static/media/parking-A.df4a3e84.svg";